import { badgeEntityName } from '../../../../../backend/features/badges/shared';
import { BadgeAccountsSelectionPanel, } from '../../../../../ui/features/badge-management/components/BadgeAccountsSelectionPanel/BadgeAccountsSelectionPanel';
import { BadgeCreateWizardStepContainer } from '../../../../../ui/features/badge-management/components/BadgeCreateWIzard/BadgeCreateWizardStepContainer';
import { useBadgingTranslation } from '../../../../../ui/hooks';
import { themeColorsDark } from '@juvare/common-web-ui/JuvareTheme/colors/themeColorsDark';
import { useStorageGet } from '@juvare/platform-sdk-react/ui/hooks';
import { AppBar, Box, Button, CircularProgress, Toolbar } from '@mui/material';
import Typography from '@mui/material/Typography';
import React from 'react';
/**
 * More Customized alternative to {@link BadgeAccountsSelectionPanelDialog}
 *
 * Looks like Create Badge wizard 3rd step
 */
export const BadgeAccountsSelectionWizardLikeDialog = (props) => {
    const { t } = useBadgingTranslation();
    const [addAccountsInProgress, setAddAccountsInProgress] = React.useState(false);
    const [selectedAccounts, setSelectedAccounts] = React.useState([]);
    const { data: badge, isLoading, error } = useStorageGet(badgeEntityName, props.badgeId);
    const handleClose = () => {
        props.onClose();
    };
    const handleSave = () => {
        if (selectedAccounts.length === 0) {
            return;
        }
        setAddAccountsInProgress(true);
        void props
            .onSave(selectedAccounts)
            .then(() => {
            props.onClose();
        })
            .finally(() => {
            setAddAccountsInProgress(false);
        });
    };
    if (isLoading) {
        return React.createElement(CircularProgress, null);
    }
    if (!badge || error) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(AppBar, { sx: {
                position: 'relative',
                maxHeight: 64,
                backgroundColor: themeColorsDark.surface.primary,
                color: themeColorsDark.text.bold,
            } },
            React.createElement(Toolbar, null,
                React.createElement(Typography, { variant: 'h6' }, t('badges.badgeDetails.accountBadgeTable.actions.addAccountDialog.title')),
                React.createElement(Box, { sx: { flexGrow: 1 } }),
                React.createElement(Button, { variant: 'text', color: 'inherit', size: 'large', onClick: handleClose }, t('badges.badgeDetails.accountBadgeTable.actions.addAccountDialog.cancelButton')))),
        React.createElement(Box, { sx: {
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                m: 3,
            } },
            React.createElement(BadgeCreateWizardStepContainer, { headerText: t('badges.badgeDetails.accountBadgeTable.actions.addAccountDialog.contentTitle'), badgeTemplateSelected: badge.data.templateSnapshot, formSettings: badge.data.formSettings, fixedBadgePreviewPosition: false },
                React.createElement(BadgeAccountsSelectionPanel, { selectedAccounts: selectedAccounts, setSelectedAccounts: setSelectedAccounts, initialStorageAccountFilters: props.initialStorageAccountFilters, showAccountSelectDialogInitially: props.showAccountSelectDialogInitially, selectedAccountsTableInfoText: props.selectedAccountsTableInfoText, sx: { p: 0 }, onClose: handleClose, onEscapeKeyDown: handleClose }))),
        React.createElement(Box, { sx: {
                mt: 3,
                px: 3,
                width: '100%',
                borderTop: '0.5px solid grey',
                borderColor: themeColorsDark.border.boldest,
                display: 'flex',
                justifyContent: 'end',
                alignItems: 'center',
            } },
            React.createElement(Button, { variant: 'contained', color: 'primary', size: 'large', sx: { mt: 1 }, onClick: handleSave, disabled: selectedAccounts.length === 0 || addAccountsInProgress }, t('badges.badgeDetails.accountBadgeTable.actions.addAccountDialog.addAccountsButton')))));
};
